import { Controller } from "@hotwired/stimulus"

// Slide-out drawer controller with backdrop, ESC to close, and Turbo Frame support
export default class extends Controller {
  static targets = ["panel", "overlay", "content"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    // Don't preventDefault for links with turbo-frame - let Turbo handle navigation
    // Only preventDefault for buttons or non-turbo links
    if (event && !event.currentTarget?.dataset?.turboFrame) {
      event.preventDefault()
    }

    this.openValue = true
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.handleKeydown)

    // Focus first input after animation
    setTimeout(() => {
      const firstInput = this.panelTarget.querySelector("input:not([type=hidden]), select, textarea")
      if (firstInput) firstInput.focus()
    }, 200)
  }

  close(event) {
    if (event) event.preventDefault()

    this.openValue = false
    this.panelTarget.classList.remove("translate-x-0")
    this.panelTarget.classList.add("translate-x-full")
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.handleKeydown)
    this.dispatchUploadSurfaceClose()
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.openValue) {
      this.close(event)
    }
  }

  // Close on successful form submission (called via Turbo Stream)
  closeOnSuccess() {
    this.close()
  }

  // Click outside to close
  clickOutside(event) {
    if (event.target === this.overlayTarget) {
      this.close(event)
    }
  }

  dispatchUploadSurfaceClose() {
    if (!this.panelTarget.querySelector("[data-controller~='dropzone']")) return

    window.dispatchEvent(new CustomEvent("upload-surface:close"))
  }
}
